'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { socialLinksMap } from '@/app/[locale]/(worlds)/profile/components/EditUserAbout';
import ProfileAvatar from '@/app/[locale]/(worlds)/profile/components/ProfileAvatar';
import FollowCountsDialogs from '@/components/FollowCountsDialogs';
import ViverseButton from '@/components/ViverseButton';
import IconEdit from '@/components/assets/icon_edit.svg';
import IconEye from '@/components/assets/icon_eye.svg';
import { SETTINGS_PATH } from '@/constants/settings';
import { useConfigsContext } from '@/context/ConfigsContext';
import { useOwnerProfileContext } from '@/context/OwnerProfileContext';
import { Link } from '@/i18n/navigation';
function PrivateProfileIntro() {
  const $ = _c(31);
  const {
    store
  } = useConfigsContext();
  const {
    setIsPublicView
  } = useOwnerProfileContext();
  const profile = store?.profile;
  const showSocialLinks = profile?.showSocialLinks;
  const socialLinks = profile?.socialLinks;
  const t = useTranslations();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ProfileAvatar variant="private" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = profile?.displayName;
  let t2;
  if ($[1] !== t1) {
    t2 = <h3 className="header-4 md:header-3">{t1}</h3>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Link href={SETTINGS_PATH}><IconEdit className="relative -top-[1.5px] size-5 cursor-pointer" /></Link>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className="flex items-center justify-center gap-2 md:justify-start">{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = profile?.userId;
  let t6;
  if ($[6] !== t5) {
    t6 = <p className="body-2 max-md:text-center">@{t5}</p>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <div className="flex flex-col">{t4}{t6}</div>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex gap-2 max-md:m-auto"><FollowCountsDialogs /></div>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== showSocialLinks || $[13] !== socialLinks) {
    t9 = showSocialLinks && socialLinks?.map(_temp);
    $[12] = showSocialLinks;
    $[13] = socialLinks;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = <div className="flex items-center gap-2 max-md:m-auto">{t9}</div>;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t7) {
    t11 = <div className="flex flex-col items-center gap-4 md:flex-row md:items-start">{t0}<div className="flex flex-col gap-2">{t7}{t8}{t10}</div></div>;
    $[17] = t10;
    $[18] = t7;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== setIsPublicView) {
    t12 = () => setIsPublicView(true);
    $[20] = setIsPublicView;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <IconEye className="mr-2 size-6" />;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t) {
    t14 = t("profile-page.intro.public-profile");
    $[23] = t;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t12 || $[26] !== t14) {
    t15 = <ViverseButton className="m-auto h-[48px] max-md:px-4 max-md:py-2 max-md:text-[14px] md:m-[inherit]" variant="secondary" onClick={t12}>{t13}{t14}</ViverseButton>;
    $[25] = t12;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t11 || $[29] !== t15) {
    t16 = <section className="px-4 py-2 md:px-8 md:py-4 lg:px-18"><div className="flex flex-col gap-4 md:flex-row md:justify-between">{t11}{t15}</div></section>;
    $[28] = t11;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  return t16;
}
function _temp(link) {
  const Icon = socialLinksMap[link.key].Icon;
  return <Link href={link.value} key={link.key} target="_blank"><ViverseButton variant="icon2" size="icon" className="size-[30px]"><Icon className="size-4" /></ViverseButton></Link>;
}
export default PrivateProfileIntro;